<template>
  <div>
    <div class="background-image-search" style="background-image: url(img/temp/blurred-dark.jpg)"></div>
    <!-- /.background-image-search -->

    <CollectionList :searchUri="'collections/getAllCollections'" :binder="this.$store.state.collections.all" :payload="{ 'userId': this.$store.state.authentication.user.user.id }" />

  </div>
</template>
<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import CollectionList from '@/views/Collections/CollectionList.vue';

export default {
  components: {
    RouteBreadCrumb,
    CollectionList
  }
};
</script>
<style>
</style>
